// Pure financial calculator formulas — pure functions, easy to test.
export const formatINR = (amount) =>
  new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0
  }).format(amount);

export const calculateSIP = ({ amount, tenureYears, annualRate }) => {
  const monthlyRate = annualRate / 100 / 12;
  const months = tenureYears * 12;
  const maturityAmount =
    amount * (((Math.pow(1 + monthlyRate, months) - 1) / monthlyRate) * (1 + monthlyRate));
  const investedAmount = amount * months;
  return {
    maturityAmount: Math.round(maturityAmount),
    investedAmount,
    returns: Math.round(maturityAmount - investedAmount)
  };
};

export const calculateEMI = ({ principal, annualRate, tenureYears }) => {
  const monthlyRate = annualRate / 100 / 12;
  const months = tenureYears * 12;
  const emi =
    (principal * monthlyRate * Math.pow(1 + monthlyRate, months)) /
    (Math.pow(1 + monthlyRate, months) - 1);
  const totalAmount = emi * months;
  return {
    emi: Math.round(emi),
    totalAmount: Math.round(totalAmount),
    totalInterest: Math.round(totalAmount - principal)
  };
};
